<template>
  <section class="card-container">
    <div v-if="documentos" class="fast">
      <h6>{{ this.$t('cards.documentos') }}</h6>
      <div class="card">
        <div class="card-content">
          <ul class="list">
            <li
              v-for="(i, index) in documentos"
              :key="i.CodigoValidacao"
              class="item"
            >
              <div
                class="link is-vcentered"
                @click="
                  openDocs(i.Codigo, i.DataSolicitacaoRelatorio, i.Prontuario)
                "
              >
                <i class="icon-ic_file_gray" /> {{ i.Descricao }}
                <i class="icon-ic_link is-pulled-right" />
              </div>
              <hr v-if="index == documentos.length - 1 ? false : true" />
            </li>
          </ul>
        </div>
      </div>
      <router-link to="/documentos" class="all is-pulled-right is-vcentered">
        {{ this.$t('botoes.ver-todos') }}
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import { NotAuthenticatedError } from '../../../models/not-authenticated-error'
import { WindowOpener } from '../../../helpers/window.helper'

export default {
  computed: {
    ...mapGetters({
      documentos: 'documentosRecentes',
      getPatientPrintDocs: 'getPatientPrintDocs'
    })
  },
  beforeMount() {
    this.getDocumentosRecentes(process.env.VUE_APP_QUANTIDADE_ITENS).catch(
      (err) => {
        if (err instanceof NotAuthenticatedError) router.push('/')
      }
    )
  },
  methods: {
    ...mapActions(['getDocumentosRecentes', 'obterDocumento']),
    async openDocs(id, date, prontuario) {
      const payload = {
        id,
        date,
        prontuario
      }
      let newWin = new WindowOpener(window, navigator)
      await this.obterDocumento({ ...payload })
        .then(() => {
          const file = new Blob([this.getPatientPrintDocs], {
            type: 'application/pdf'
          })
          const fileURL = URL.createObjectURL(file)
          newWin.open(fileURL)
        })
        .catch((err) => {
          throw err
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/card';

.card-container {
  clear: both;
}

.fast {
  .card {
    max-height: 19.375rem;
  }

  .card-content {
    padding-top: 1.5625rem;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .list {
    .item {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;

      .link {
        cursor: pointer;

        i {
          vertical-align: bottom;
        }
      }
    }
  }

  .text {
    p {
      height: 1.5rem;
      width: 23.448125rem;

      color: var(--gray-700);
      font-family: Roboto;
      font-size: 1rem;
      line-height: 1.5rem;
    }

    span {
      padding-top: 0.625rem;
      height: 1rem;
      width: 13.150625rem;

      color: var(--gray-500);
      font-family: Roboto;
      font-size: 0.875rem;
      line-height: 1rem;
    }
  }
}
@media (max-width: 64rem) {
  .fast {
    .list .item {
      .link {
        display: flex;
        i {
          float: right;
          margin-right: 0.5rem;
        }
        :last-child {
          flex-grow: 2;
          text-align: right;
        }
      }
    }
    .card {
      height: 100%;
    }
  }
}
</style>
